import { useEffect } from "react";
import Get from "../../api/Get";
import { MY_APPOINTMENT } from "../../api/Routes";
import {Row, Col, Alert, Accordion, Card, Button} from "react-bootstrap"
import ReactPaginate from "react-paginate";
import { RiArrowLeftSLine, RiArrowRightSLine } from "react-icons/ri";
import { useState } from "react";
import moment from "moment";

export default function AtencionesPrevias({cita, auth, setShowModalServer, setErrorServer}){
    const [citas, seCitas] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(0)

    const postsPerPage = 10;
    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;

    useEffect(() => {
        //console.log(cita)
        Get({url: `${MY_APPOINTMENT}/${cita.patientDTO?.id}`, access_token: auth.data.access_token})
        .then(response => {
            //console.log(response)
            const sorted = response.data.data.response.filter(item => moment(item.scheduleDTO?.dateTimeInit).isBefore(cita.scheduleDTO?.dateTimeInit))
            //console.log(sorted)
            let pageCounter = Math.ceil(sorted.length / postsPerPage)
            setPageCount(pageCounter)
            //console.log(sorted)
            seCitas(sorted)
        })
        .catch(error => {
            console.log(error)
        })
    }, [])

    const handlePageClick = (data) => setCurrentPage(data.selected + 1)

    return (
        <div className="p-3 pt-4 position-relative">
            <Row>
                <Col>
                {citas.length === 0 && <Alert variant="info">No existen citas previas</Alert>}
                    {
                        citas.slice(indexOfFirstPost, indexOfLastPost).map((item, index) => (
                            <div key={index} className="mb-2">
                                {
                                    item.appointmentStatus === 'Fallida' &&
                                    <span className="d-inline-block badge indicador-fallida">Consulta Fallida</span>
                                }
                                <h6 className="m-0">
                                    {moment(item.scheduleDTO?.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format("DD/MM/YYYY HH:mm")}
                                </h6>
                                <span>
                                    {item.speciality?.name} / {item.scheduleDTO?.name_doctor}
                                </span>
                                <Accordion>
                                    <Card>
                                        <Card.Header className="p-0">
                                            <Accordion.Toggle as={Button} variant="link" eventKey={index.toString()}>
                                                Ver Historia Clínica
                                            </Accordion.Toggle>
                                        </Card.Header>
                                        <Accordion.Collapse eventKey={index.toString()}>
                                            <Card.Body>
                                                <Row>
                                                    <Col>
                                                    {   Object.keys(item.medicalHistoryDTO).length > 0  &&
                                                        item.medicalHistoryDTO?.questionsDTOList.slice(0,1).map((item,i)=>(
                                                                item.questionOfGroupDTOS.length > 0 &&
                                                                <div key={i}>
                                                                    <label className="font-weight-bold font-size-08rem mb-1 text-secondary">{item.questionGroup}</label>
                                                                    <ul className="list-unstyled font-size-08rem pl-3 color-989898 mb-0">
                                                                        {
                                                                            item.questionOfGroupDTOS.map((subIt,subI)=>(
                                                                                <li key={subI}>
                                                                                    <span className="font-weight-bold-600">{subIt.label}: </span>
                                                                                    { 
                                                                                        (subIt.qualificationDTOS.length > 0) ? subIt.qualificationDTOS.filter( q => q?.selected === 'selected')[0]?.label
                                                                                        : subIt.note 
                                                                                    }
                                                                                </li>
                                                                            ))
                                                                        }                        
                                                                    </ul>
                                                                </div>
                                                            ))
                                                        }
                                                        <ul className="list-unstyled font-size-08rem pl-3 color-989898">
                                                            <li>
                                                                <span className="font-weight-bold-600">Receta: </span>
                                                                {
                                                                    (item.receta && item.receta !== undefined) ? 
                                                                    item.receta.medicamentoList.map((rec, idx) => (
                                                                        <div key={idx}>
                                                                            <label>{`${rec.dias}d - ${rec.horas}h - ${rec.medicamento}`}</label>{' '}
                                                                            <label>({rec.indicaciones})</label>
                                                                            {item.receta.medicamentoList.length > 1 && <hr />}
                                                                        </div>
                                                                    )) :
                                                                    '-'
                                                                }
                                                            </li>
                                                            <li>
                                                                <span className="font-weight-bold-600">Diagnóstico: </span>
                                                                {item.diseaseList.length === 0 && '-'}
                                                                {
                                                                    item.diseaseList.map((dis, idx) => (
                                                                        <label key={idx} className="d-block">{`${dis.diseaseType?.name}: ${dis.disease.code4digits} ${dis.disease.description}`}</label>
                                                                    ))
                                                                }
                                                            </li>
                                                            <li>
                                                                <span className="font-weight-bold-600">Remisiones: </span>
                                                                {item.ordenRemisiones.length === 0 && '-'}
                                                                {
                                                                    item.ordenRemisiones.map((rem, idx) => (
                                                                        <label key={idx} className="d-block">{rem.nombre}</label>
                                                                    ))
                                                                }
                                                            </li>
                                                            <li>
                                                                <span className="font-weight-bold-600">Estudios imagenológicos: </span>
                                                                {item.estudioImagenologicos.length === 0 && '-'}
                                                                {
                                                                    item.estudioImagenologicos.map((img, idx) => (
                                                                        <label key={idx} className="d-block">{img.nombre}</label>
                                                                    ))
                                                                }
                                                            </li>
                                                            <li>
                                                                <span className="font-weight-bold-600">Recomendación médica: </span>
                                                                <label className="d-block">{item?.medicalRecommendation ?? '-'}</label>
                                                            </li>
                                                            <li>
                                                                <span className="font-weight-bold-600">Laboratorios: </span>
                                                                {item.ordenLaboratorios.length === 0 && '-'}
                                                                {
                                                                    item.ordenLaboratorios.map((img, idx) => (
                                                                        <label key={idx} className="d-block">{img.nombre}</label>
                                                                    ))
                                                                }
                                                            </li>
                                                        </ul>
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>
                                    </Accordion>
                                <hr />
                            </div>
                        ))
                    }
                </Col>
            </Row>
            {citas.length > 0 && <Row className="mt-3">
                <Col>
                    <ReactPaginate
                        previousLabel={<RiArrowLeftSLine />}
                        nextLabel={<RiArrowRightSLine />}
                        breakLabel={'...'}
                        breakClassName={'break-me'}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={3}
                        onPageChange={handlePageClick}
                        containerClassName={'pagination'}
                        subContainerClassName={'pages pagination'}
                        activeClassName={'active'}
                    />
                </Col>
            </Row>}
        </div>
    )

}